import React from "react";
import { AHIcon, AHText, Box } from "arkh";
import { OrganisationHeaderHeight } from "./OrganisationHeader";

import { TimezoneIndicator } from "./TimezoneIndicator";
import { FormattedMessage } from "react-intl";

export function StoreBanner(props: { storeName: string; insetTop?: number }) {
  return (
    <Box
      style={{
        paddingTop: props.insetTop ?? 0,
        height: OrganisationHeaderHeight + (props.insetTop ?? 0),
        backgroundColor: "#343437",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",

        width: "100%",
      }}
      spaceHorizontal="medium"
    >
      <AHText color="text-inverted" type="subtitle">
        <AHIcon
          type="store"
          size="small"
          color="text-inverted"
          spaceRight="small"
        />
        {props.storeName}
      </AHText>
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText color="text-inverted" type="detail" spaceRight="small">
          <FormattedMessage
            defaultMessage="Date and time is displayed in unit timezone"
            description="Store timezone indicator description"
          />
        </AHText>
        <TimezoneIndicator />
      </Box>
    </Box>
  );
}
